export default __webpack_public_path__ + "static/media/Icon42.ecbcaefc.svg";